export const CODE_LENGTH = 6;

export const sanitizeCode = (value) => value.replace(/\D/g, '').slice(0, CODE_LENGTH);

export const isCodeComplete = (code) => new RegExp(`^\\d{${CODE_LENGTH}}$`).test(code || '');

// Maps backend responses of checkVerificationCode / checkResetCode to a translated message
export const getCodeErrorMessage = (status, data, t) => {
  const text = typeof data === 'string' ? data : '';

  if (status === 429) {
    return t('error.tooManyAttempts');
  }
  if (text.includes('Invalid code format')) {
    return t('error.invalidCodeFormat');
  }
  if (text.includes('Code expired')) {
    return t('error.codeExpired');
  }
  if (status === 404) {
    return t('error.invalidCode');
  }
  return null;
};
